import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

const formatCurrency = (value: number) =>
	new Intl.NumberFormat("pt-PT", {
		style: "currency",
		currency: "EUR",
		maximumFractionDigits: 2,
	}).format(value);

const normalizeNumber = (value: number | null | undefined) => {
	const parsed = Number(value ?? 0);
	return Number.isNaN(parsed) ? 0 : parsed;
};

type ClosedRepairEntry = {
	repNum?: string | number | null;
	quotation?: number | null;
	value?: number | null;
};

type ClosedRepairsByTechnicianTableProps = {
	repairs: ClosedRepairEntry[];
};

export function ClosedRepairsByTechnicianTable({
	repairs,
}: ClosedRepairsByTechnicianTableProps) {
	return (
		<div className="rep_table overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead className="w-[180px]">#Rep</TableHead>
						<TableHead>Orçamento</TableHead>
						<TableHead className="w-[180px]">Valor</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{repairs.map((repair, index) => {
						const rowKey = repair.repNum ?? `repair-${index}`;
						return (
							<TableRow key={rowKey}>
								<TableCell>{repair.repNum ?? "-"}</TableCell>
								<TableCell>
									{formatCurrency(normalizeNumber(repair.quotation))}
								</TableCell>
								<TableCell>
									{formatCurrency(normalizeNumber(repair.value))}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</div>
	);
}
